module.exports = __webpack_public_path__ + "static/img/00080B_1_2_R_20190724_LC.632d837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00080B_1_2_R_20190724_LC.png
// module id = k/RD
// module chunks = 0